import React from "react";

class TableFormatter {
    public verticalLineSeparator = (cell: any, row: any) => {
        return (              
            <div style={{ borderLeft:"1px solid #707070", top: "20%", bottom: "20%", position: "absolute", paddingRight: "10px"}}/>
          );
    }
}

const tableFormatter = new TableFormatter();
export default tableFormatter;